<template>
  <v-card class="pa-7" light outlined>
    <v-container fluid>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center" src="https://swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="70px" contain/>
      </div>
      <h1 class="text-center">{{ $t('title') }}</h1>
      <div v-if="verifiedAccounts.length > 0">
        <p class="text-center mb-10 mt-2">{{ $t('description') }}</p>
        <v-select :items="verifiedAccounts" item-value="id" item-text="identifier" :label="$t('label')" :placeholder="$t('placeholder')" v-model="accountSelected" outlined/>
        <v-btn v-if="this.accountSelected !== 0" style="width: 100%" class="button-register" @click="registerParticipant" dark>
          {{ $t('btnRegister') }}
        </v-btn>
        <p v-if="this.accountSelected !== 0" style="font-size: 14px; color: #5a5a5a" class="text-center mb-n1 mt-3">{{ $t('registering') }}
          <a style="font-size: 14px; color: #5a5a5a" href="https://swiset.com/terms-and-conditions/" target="_blank">{{ $t('termsAndConditions') }}</a>.</p>
      </div>
      <p v-else-if="mandatoryBroker !== null" class="text-center mb-7 mt-2" v-html="$t('notVerifiedAndMandatoryBroker', { broker: mandatoryBroker.name, ibUrl: mandatoryBroker.iburl })"/>
      <p v-else class="text-center mb-7 mt-2" v-html="$t('notVerified')"/>
    </v-container>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/tournament';
import { mapMutations } from 'vuex';
export default {
  name: "TournamentRegisterCollapsed",
  data() {
    return {
      verifiedAccounts: [],
      accountSelected: 0,
      mandatoryBroker: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.verifiedAccounts = this.$store.state.user.brokerAccounts.filter((account) => account.verified);
      this.mandatoryBroker = this.$store.state.tournament.mandatoryBroker;
      if(this.mandatoryBroker !== null)
        this.verifiedAccounts = this.verifiedAccounts.filter((account) => account.broker.id === this.mandatoryBroker.id);
    },
    ...mapMutations(['setTournament']),
    registerParticipant() {
      let tournamentParticipant = {
        tournament: { id: this.$store.state.tournament.tournamentId },
        assignedAccount: { id: this.accountSelected },
        user: { id: this.$store.state.user.id },
      };

      Repository.enrollParticipant(tournamentParticipant).then((response) => {
        if(response.status < 400) {
          alert(`Congrats! You were successfully register to the tournament.`);
          Repository.getTournamentOverview(this.$store.state.tournament.tournamentId).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setTournament(secondResponse.data);
          });
        }
      });
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "It's your Time!",
    "description": "You can register to the tournament with a verified account.",
    "label": "Verified Broker Account",
    "placeholder": "E.g. Sim 101",
    "btnRegister": "Register Now",
    "registering": "By registering, you agree with tournament",
    "termsAndConditions": "terms and conditions",
    "notVerified": "You cannot register to the tournament.<br>You need at least one verified account.",
    "notVerifiedAndMandatoryBroker": "You cannot register to the tournament<br>You need a verified account of <b>{broker}</b><br>You can open an account by <a href='{ibUrl}' target='_blank'>clicking here</a>"
  },
  "es": {
    "title": "¡Es tú momento!",
    "description": "Puedes registrarte al torneo con una cuenta verificada.",
    "label": "Cuenta de Broker Verificada",
    "placeholder": "Ejemplo: Sim 101",
    "btnRegister": "Registrate Ahora",
    "registering": "Registrándote aceptas del torneo sus",
    "termsAndConditions": "términos y condiciones",
    "notVerified": "No puedes registrarte al torneo.<br>Necesitas al menos una cuenta verificada.",
    "notVerifiedAndMandatoryBroker": "No puedes registrarte al torneo<br>Necesitas una cuenta verificada de <b>{broker}</b><br>Si no tienes una cuenta, ábrela <a href='{ibUrl}' target='_blank'>dando click aquí</a>"
  }
}
</i18n>

<style scoped>
  .button-register {
    background-color: #00F784 !important;
    color: #111111 !important;
    border: #00F784 solid 1px;
  }
</style>
